import { NgModule } from '@angular/core'
import { JmlLibModule, PermissionsModule } from '@dot-it/jml-lib'
import { CustomLibRoutingModule } from './custom-lib.routing.module'

@NgModule({
  declarations: [],
  imports: [JmlLibModule, PermissionsModule, CustomLibRoutingModule],
  exports: []
})
export class CustomLibModule {}
